import React, { useEffect, useState } from 'react';
import LandingHeader from '../ui/LandingHeader';
import LandingFooter from '../ui/LandingFooter';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export const termsAndConditionsPageTitle = "Terms and Conditions";

const TermsAndConditionsPage: React.FC = () => {
    const [content, setContent] = useState<string>('');

    useEffect(() => {
        fetch('/legal/TermsAndConditions.md')
            .then(response => response.text())
            .then(text => setContent(text))
            .catch(error => console.error('Error loading terms and conditions:', error));
    }, []);

    return (
        <div>
            <div className="relative z-10">
                <LandingHeader />
            </div>
            <main className="container mx-auto px-4 py-6 sm:py-6 flex-grow mt-16">
                <div className="mx-auto max-w-3xl">
                    <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-3xl text-center mb-8">
                        {termsAndConditionsPageTitle}
                    </h1>
                    <div className="prose prose-lg max-w-none prose-headings:font-bold prose-h1:text-4xl prose-h2:text-3xl prose-h3:text-2xl prose-h4:text-xl prose-p:text-gray-700 prose-a:text-blue-600 hover:prose-a:text-blue-800 prose-strong:text-gray-900 prose-code:bg-gray-100 prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-code:text-gray-900 prose-pre:bg-gray-900 prose-pre:text-gray-100 prose-pre:rounded-lg prose-pre:p-4 prose-pre:overflow-x-auto prose-blockquote:border-l-4 prose-blockquote:border-gray-300 prose-blockquote:pl-4 prose-blockquote:italic prose-blockquote:text-gray-600 prose-ul:list-disc prose-ol:list-decimal prose-li:marker:text-gray-500">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {content}
                        </ReactMarkdown>
                    </div>
                </div>
            </main>
            <LandingFooter />
        </div>
    );
};

export default TermsAndConditionsPage; 